import React, { useEffect, useState } from "react";
import { Wrapper } from "./Panel";
import { ReactComponent as CloseIcon } from "../../.././../../assets/svg/solobuilder/close-icon.svg";
import { guessTextColor } from "../helpers/guessTextColor";
import { useSelector } from "react-redux";
import { ColorPicker } from "./ColorPicker";
interface IDropShadow {
  key: string;
  label: string;
  value: string;
  style?: any;
  open: () => void;
  placeholder:any;
  visible: boolean;
}
export const DropShadow: React.FC<IDropShadow> = (props) => {
  const { key, label, value, open, placeholder, visible} = props;
  
  return (
    <Wrapper key={key}>
    <p className="panel-label">
        {label}
    </p>
    <p
        className="font-medium rounded-md cursor-pointer flex items-center justify-center"
        style={{
            color: "#0466C8",
            backgroundColor: "rgba(4, 102, 200, 0.1)",
            height: "28px",
            width: "170px",
            padding: "5px"
        }}
        onClick={((e:any) => {e.stopPropagation(); open() })}
    >
        <div className="flex h-full items-center justify-between">
            <p>{placeholder}</p>
        </div>
    </p>
</Wrapper>
  );
};
interface IDropShadowMenu {
  close: () => void;
  isCheckedIn: boolean;
  dropShadowContext: any;
  onChange: (key: string, value: any) => void;
  setDropShadowContext: (values: any) => void;
  open:()=>void;
}

export const DropShadowMenu: React.FC<IDropShadowMenu> = (
  props: IDropShadowMenu
) => {
  const { close, dropShadowContext, onChange, setDropShadowContext ,open} = props;
  const { where } = dropShadowContext;
  const {color,x,y,blur,spread}=dropShadowContext?.value || {}
  const {colorPickerContext}=useSelector((state:any)=>state.common);
  let value=colorPickerContext?.value
  const IValues = {
    color:"",
    x:"",
    blur:"",
    y:"",
    spread:""
  }
  const [values,setValues]=useState(dropShadowContext.value || IValues)

  useEffect(()=>{
    if(value) {
      setValues((val:any)=> ({...val,color:value}));
     }
  },[value])

  useEffect(()=> {
    setDropShadowContext((value:any)=>({...value,value:values}))
    onChange(where, values)
  },[values,value])

  useEffect(() => {
    document.addEventListener('keydown', detectKeyDown)
    return () => {
      document.removeEventListener('keydown', detectKeyDown);
    }
  }, [])

  const detectKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      close();
    }
  }

  return (
    <div className="custom-color" style={{ height: "147px", bottom: 10 }} onClick={(e)=>e.stopPropagation()}>
      <div
        className="w-full h-10 flex justify-between items-center text-xs font-semibold "
        style={{
          background: "#EFF0F4",
          padding: "0px 10px"
        }}
      >
        <div style={{fontSize:"12px",fontWeight:600}}>Drop shadow</div>
        <CloseIcon
          className="cursor-pointer"
          onClick={() => close()}
        ></CloseIcon>
      </div>
      <div style={{padding: "0px 10px"}}><ColorPicker pickerkey="shadow-color" label="Color" value={color ? color : value?.color} open={open} close={close} visibility={colorPickerContext?.visibility}/></div>
      <div className="flex flex-row justify-between items-center" style={{padding: "10px 10px 0px"}}>
        <div className="flex flex-row justify-between items-center">
          <div
            className="mr-2 text-xs font-semibold"
            style={{fontSize:"11px",fontWeight:600,color:"#282B31"} }
          >
            X
          </div>
          <input
            id={where}
            className="panel-input"
            style={{height:24,width:60}}
            placeholder="0"
            onChange={(e)=>setValues({...values,"x":e.target.value})}
            value ={x ? x : ""}
         />
           
        </div>
        <div className="flex flex-row justify-between items-center">
          <div
            className="mr-2 text-xs font-semibold"
            style={{ marginLeft: "10px" ,marginRight:"10px", fontSize:"11px",fontWeight:600,color:"#282B31"}}
          >
            Blur
          </div>
          <input
            id={where}
            className="panel-input"
            style={{height:24,width:60}}
            placeholder="0"
            onChange={(e)=>setValues({...values,"blur":e.target.value})}
            value= {blur ? blur : ""}
          />
        </div>
      </div>
      <div className="flex flex-row justify-between items-center" style={{padding: "10px 10px 0px"}}>
        <div className="flex flex-row justify-between  items-center" >
          <div
            className="mr-2 text-xs font-semibold"
            style={{fontSize:"11px",fontWeight:600,color:"#282B31"} }
          >
            Y
          </div>
          <input
            id={where}
            className="panel-input"
            style={{height:24,width:60}}
            placeholder="0"
            value= {y ? y : ""}
            onChange={(e)=>setValues({...values,"y":e.target.value})}
         />
        </div>
        <div className="flex flex-row justify-between items-center" >
          <div
            className="mr-2 text-xs font-semibold"
            style={{ marginLeft: "10px", fontSize:"11px",fontWeight:600,color:"#292D32"}}
          >
            Spread
          </div>
          <input
            id={where}
            className="panel-input"
            style={{height:24,width:60}}
            placeholder="0"
            onChange={(e)=>setValues({...values,"spread":e.target.value})}
            value ={spread ? spread : ""}
          />
        </div>
      </div>
    </div>
  );
};
